'use client';
import { useCallback } from 'react';
import { isFunction } from '@s7/utils';

var setRef = function(ref, value) {
    if (isFunction(ref)) {
        ref(value);
    } else if (ref !== null && ref !== undefined) {
        ref.current = value;
    }
};
var mergeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        return refs.forEach(function(ref) {
            return setRef(ref, node);
        });
    };
};
/**
 * Выполняет слияние ref.
 *
 * Мотивация использования useCallback:
 * https://github.com/gregberge/react-merge-refs/issues/5
 * */ var useMergedRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return useCallback(mergeRefs.apply(void 0, [].concat(refs)), refs);
};

export { mergeRefs, useMergedRefs };
